<template>
    <section>
        <MainLayout>
            <div class="container">
                <div class="box pt-sm-3">
                    <b-form-group class="col-12 col-md-6 mb-4" label="Seleccione un reporte">
                        <b-select v-model="reportSelected" >
                            <b-select-option value="rates">Tarifario</b-select-option>
                            <b-select-option value="agency-payment">Cobros de Agencia</b-select-option>
                            <b-select-option value="supplier-payment">Pago Proveedores</b-select-option>
                            <b-select-option value="operations">Operaciones</b-select-option>
                            <b-select-option value="comercial">Comercial</b-select-option>
                            <b-select-option value="supplier-stadistics">Estadisticas de proveedor</b-select-option>
							<b-select-option value="google-data-studio">Google Analytics</b-select-option>
                            <b-select-option value="additionals">Adicionales</b-select-option>
                            <b-select-option value="spit">SPIT</b-select-option>
                            <b-select-option value="reviews">Reseñas</b-select-option>
                            <b-select-option value="booking-incidents">Booking Incidents</b-select-option>
                            <b-select-option value="driver-events">Driver Events</b-select-option>
                            <b-select-option value="driver-chat">Driver Chat</b-select-option>
                        </b-select>
                    </b-form-group>
					<hr>
                    <div class="container">
						<rates s v-if="reportSelected==='rates'"></rates>
						<SupplierStadistics v-if="reportSelected==='supplier-stadistics'"></SupplierStadistics>
						<SalesChannelPayments v-if="reportSelected==='agency-payment'"></SalesChannelPayments>
						<SupplierPayments v-if="reportSelected==='supplier-payment'"></SupplierPayments>
						<Operations v-if="reportSelected==='operations'"></Operations>
						<Comercial v-if="reportSelected==='comercial'"></Comercial>
						<GoogleDataStudio v-if="reportSelected==='google-data-studio'" />
                        <Additionals v-if="reportSelected==='additionals'" />
                        <Spit v-if="reportSelected==='spit'" />
                        <Reviews v-if="reportSelected==='reviews'" />
                        <BookingIncidents v-if="reportSelected==='booking-incidents'" />
                        <DriverEvents v-if="reportSelected==='driver-events'"/>
                        <DriverChat v-if="reportSelected==='driver-chat'"/>
                    </div>
                </div>
                <!---<b-card no-body>
                    <b-tabs pills card vertical small no-fade nav-class="nav-style">
                        <b-tab title="Cobro Agencias" active><SalesChannelPayments></SalesChannelPayments></b-tab>
                        <b-tab title="Pago proveedores"><SupplierPayments></SupplierPayments></b-tab>
                        <b-tab title="Operaciones"><Operations></Operations></b-tab>
                        <b-tab title="Comercial"><Operations></Operations>></b-tab>
                        <b-tab title="Estadisticas de proveedor"><SupplierStadistics></SupplierStadistics></b-tab>
                    </b-tabs>
                </b-card>-->
            </div>
        </MainLayout>
    </section>
</template>

<script>
    import MainLayout from '../layout/MainLayout.vue'
    import SalesChannelPayments from './singles/SalesChannelPayments'
    import SupplierPayments from './singles/SupplierPayments'
    import Operations from './singles/Operations'
    import Comercial from './singles/Comercial'
    import SupplierStadistics from './singles/SupplierStadistics'
    import Rates from './singles/Rates'
	import GoogleDataStudio from './singles/GoogleDataStudio'
    import Additionals from './singles/Additionals.vue'
    import Spit from './spit/Index.vue'
    import Reviews from './reviews/index.vue'
    import BookingIncidents from './singles/BookingIncidents.vue'    
    import DriverEvents from './driverEvents/DriverEvents.vue'
    import DriverChat from './driverChat/DriverChat.vue'


    export default {
        components: { 
            MainLayout, 
            SalesChannelPayments, 
            SupplierPayments, 
            Operations, 
            Comercial, 
            SupplierStadistics, 
            Rates, 
            GoogleDataStudio, 
            Additionals, 
            Reviews, 
            Spit, 
            BookingIncidents, 
            DriverEvents, 
            DriverChat 
        },
        name: "single",
        data(){
            return{
                reportSelected:"rates"
            }
        },

        methods:{
            loadReport(reportCode){
                this.reportSelected = reportCode;
            }
        }

    }
</script>

<style scoped>
    div >>>.table-container {
        max-height: 400px; overflow-y: scroll !important;
    }
    div >>> .async-tables .row0 td{
        background-color: #dcdcdc !important;
        font-weight: bold;
    }
</style>
